<template>
  <div class="con">
    <div class="con-wrap">
      <div class="con_title">{{ title }}</div>
      <div class="con_list clearfix">
        <div class="video-list" v-for="(item, index) in solutionList" :key="index">
          <div class="video-wrap">
            <div class="video-dialog" v-show="item.videoShow">
              <div class="bg"></div>
              <div class="video-con">
                <div class="close" @click="close(item, index)"></div>
                <video @click.stop="stop(item, index)" :ref="`video${index}`" class="video" width="285" height="180" loop controls>
                  <source :src="item.videoUrl" type="video/mp4" />
                </video>
              </div>
            </div>
            <div class="mask">
              <img class="img" :src="item.imgUrl" />
              <div class="start-wrap" @click.stop="start(item, index)">
                <div class="icon"></div>
                <div class="text">{{ item.text }}</div>
              </div>
            </div>
          </div>
          <div class="link" @click="dialogShow">{{ item.link }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: String,
    solutionList: Array,
  },
  computed: {
    ...mapState('semTest', ['uuidInfo']),
  },
  data() {
    return {
      openSwitch: 0,
    }
  },
  methods: {
    start(item, index) {
      // item.maskShow = false
      item.videoShow = true
      // this.$set(item, 'imgShow', true)
      this.$refs[`video${index}`][0].play()
    },
    stop(item, index) {
      item.maskShow = true
      // this.$refs[`video${index}`][0].pause()
    },
    close(item, index) {
      item.videoShow = false
      this.$refs[`video${index}`][0].pause()
    },
    dialogShow() {
      // abTest埋点，四屏行业实践【免费试用】点击
      this.$tsignData.track('sempc_fourthpage_test_click', {
        uuid: this.uuidInfo, // 用户唯一标识
      })
      // fourthpage,表示网页四屏的入口
      this.$emit('showDialog', 'fourthpage')
    },
  },
}
</script>

<style lang="less" scoped>
.con {
  height: 736px;
  background: #fff;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .con-wrap {
    width: 1200px;
  }
  .con_title {
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
    margin-bottom: 60px;
    text-align: center;
  }
  .con_list {
    width: 100%;
    .video-list {
      float: left;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 60px;
      &:hover {
        .link {
          color: #e61717;
        }
      }
      .video-wrap {
        width: 285px;
        height: 180px;
        position: relative;
      }
      .video-dialog {
        .close {
          position: absolute;
          right: 0;
          width: 50px;
          height: 50px;
          background: url('../../../../assets/images/close.png') no-repeat;
          background-size: contain;
          margin-top: -50px;
          margin-right: -50px;
        }
        .bg {
          position: fixed;
          z-index: 9999;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 0.5);
        }
        .video-con {
          position: fixed;
          z-index: 99999;
          top: 50%;
          left: 50%;
          margin-top: -250px;
          margin-left: -350px;
          width: 800px;
          height: 500px;
        }
      }

      .video {
        width: 100%;
        height: 100%;
        object-fit: fill; // 重点
        border-radius: 6px;
      }
      .mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: rgba(28, 35, 58, 0.5);
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        &:hover {
          transform: scale(1.03);
        }
        .start-wrap {
          position: absolute;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          top: 50%;
          left: 50%;
          margin-top: -60px;
          margin-left: -60px;
          width: 120px;
          width: 120px;
          .text {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #fffdfd;
            line-height: 28px;
            margin-top: 14px;
          }
          .icon {
            width: 65px;
            height: 65px;
            margin-top: 12px;
            background: url('../../../../assets/images/solutionStart.png');
            background-size: contain;
            background-repeat: no-repeat;
            -webkit-animation-name: scaleDraw;
            /*关键帧名称*/
            -webkit-animation-timing-function: ease-in-out;
            /*动画的速度曲线*/
            -webkit-animation-iteration-count: infinite;
            /*动画播放的次数*/
            -webkit-animation-duration: 5s;
            /*动画所花费的时间*/
          }
        }
      }
      .link {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        text-align: center;
        margin-top: 20px;
        cursor: default;
        &:hover {
          color: #e61717;
        }
      }
    }
  }
}
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0% {
    transform: scale(1);
    /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1);
    /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
</style>
